import PageShell from "@/components/PageShell";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";

export default function AboutPage({ onLead }) {
  return (
    <PageShell backdrop="/homes/hero-interior.webp" title="About Akashdeep Ghai — My First Home Mortgage Ltd">
      <About onLead={onLead} />
      <Testimonials onLead={onLead} />
    </PageShell>
  );
}
